export interface RedirectionProps {
  hasHyperlink?: boolean;
  linkRedirect?: string;
  typeLink?: 'a-href' | 'click-tag';
}

export const generateRedirectionHTML = ({props, id, isMainContainer}: {props: RedirectionProps, id: string, isMainContainer?: boolean}) => {
  const { hasHyperlink = true, typeLink = 'a-href' } = props;

  if (!hasHyperlink) {
    return '';
  }

  if (isMainContainer && typeLink === 'click-tag') {
    return 'onclick="window.open(window.clickTag, \'_blank\')"';
  }

  return typeLink === 'a-href'
    ? `onclick="redirectToURL(${`'${id}'`}, event)"`
    : `onclick="redirectClickTag(${`'${id}'`}, event)"`;
};
